import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";

const productCards = [
  {
    title: "WhatsApp Marketing",
    desc: "Reach and engage customers instantly via WhatsApp messages.",
    href: "/whatsapp-marketing",
    icon: "💬",
  },
  {
    title: "Click to WhatsApp Ads",
    desc: "Start chats instantly from ads on WhatsApp.",
    href: "/click-to-wa-ads",
    icon: "📣",
  },
  {
    title: "WhatsApp Chatbots",
    desc: "Automate customer chats on WhatsApp 24/7.",
    href: "/whatsapp-chatbots",
    icon: "🤖",
  },
  {
    title: "WhatsApp Payments",
    desc: "Send and receive payments directly on WhatsApp.",
    href: "/#whatsapp-payments",
    icon: "💳",
  },
  {
    title: "Whatsapp Forms",
    desc: "Collect user data seamlessly through WhatsApp.",
    href: "/whatsapp-forms",
    icon: "📝",
  },
  {
    title: "WhatsApp Broadcast",
    desc: "Send approved, personalized messages at scale-segment, schedule, track.",
    href: "/whatsapp-broadcast",
    icon: "📣",
  },
  {
    title: "WhatsApp Button",
    desc: "Easily connect with customers via a clickable WhatsApp button.",
    href: "/whatsapp-button",
    icon: "🔘",
  },
  {
    title: "WhatsApp Link & QR",
    desc: "Connect instantly through a shareable link or scannable QR code.",
    href: "/whatsapp-link-qr",
    icon: "🔗",
  },
];

const ProductsData = () => {
  const [open, setOpen] = useState(false);
  const timerRef = useRef(null);

  const handleEnter = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setOpen(true);
  };

  const handleLeave = () => {
    // small delay so it doesn’t flick instantly
    timerRef.current = setTimeout(() => setOpen(false), 180);
  };

  const cardBg = "linear-gradient(135deg, #F4F7FC 0%, #DDEAFF 100%)";
  const iconChip = {
    flexShrink: 0,
    width: 48,
    height: 48,
    borderRadius: 10,
    background: "rgba(255,255,255,0.65)",
    border: "1px solid rgba(255,255,255,0.7)",
    display: "grid",
    placeItems: "center",
    backdropFilter: "saturate(180%) blur(8px)",
    WebkitBackdropFilter: "saturate(180%) blur(8px)",
    overflow: "hidden",
    fontSize: 24, // emoji size
  };

  return (
    <div
      className="mx-3 position-relative"
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
      style={{ display: "inline-block" }}
    >
      {/* Trigger */}
      <span
        className="text-dark fw-normal"
        style={{ fontFamily: "Poppins", fontSize: 18, cursor: "pointer" }}
        role="button"
        tabIndex={0}
      >
        Products
      </span>

      {/* Dropdown */}
      <div
        className={`vs-products-dropdown ${open ? "show" : ""}`}
        style={{
          position: "absolute",
          top: "100%",
          left: 0,
          marginTop: 10,
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 12px 32px rgba(16,24,40,0.12)",
          padding: 16,
          width: "clamp(320px, 60vw, 860px)",
          zIndex: 1000,
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, minmax(260px, 1fr))",
            gap: 16,
          }}
        >
          {productCards.map((card) => (
            <Link
              key={card.title}
              to={card.href}
              className="text-decoration-none"
              style={{
                background: cardBg,
                borderRadius: 12,
                padding: "14px 16px",
                display: "flex",
                alignItems: "center",
                gap: 14,
                transition: "transform .15s ease, box-shadow .15s ease",
                color: "#0f172a",
              }}
            >
              {/* Replaced <img /> with emoji icon */}
              <span style={iconChip} aria-hidden="true">
                {card.icon}
              </span>

              <div style={{ flex: 1, minWidth: 0 }}>
                <div
                  style={{
                    fontSize: 16,
                    fontWeight: 700,
                    marginBottom: 4,
                    color: "#161a22ff",
                  }}
                >
                  {card.title}
                </div>
                <div
                  style={{
                    fontSize: 14,
                    lineHeight: 1.2,
                    color: "#475569",
                  }}
                >
                  {card.desc}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <style>{`
        .vs-products-dropdown {
          pointer-events: none;
          opacity: 0;
          transform: translateY(8px);
          transition: opacity .2s ease, transform .2s ease;
        }
        .vs-products-dropdown.show {
          pointer-events: auto;
          opacity: 1;
          transform: translateY(0);
        }
        .vs-products-dropdown a:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 18px rgba(0,0,0,0.08);
        }
      `}</style>
    </div>
  );
};

export default ProductsData;
